var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTracker = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4724 4.00774C10.395 4.20373 6.24697 8.31682 6.01106 13.3935C5.90859 15.5564 6.52042 17.6929 7.75224 19.4736C8.98406 21.2544 10 22.3333 11.3333 23.6667L14.997 27.4675C15.0795 27.6279 15.2046 27.7624 15.3585 27.8564C15.5125 27.9503 15.6893 28 15.8697 28C16.05 28 16.2269 27.9503 16.3809 27.8564C16.5348 27.7624 16.6599 27.6279 16.7424 27.4675L20.3333 23.6667C21.6667 22.3333 22.3333 21.3333 23.8433 19.6584C25.3333 18 25.7259 15.9452 25.7262 13.8632C25.7262 12.535 25.458 11.2206 24.9376 9.99865C24.4172 8.77671 23.6554 7.67245 22.6978 6.75211C21.7403 5.83176 20.6067 5.11428 19.3651 4.6427C18.1235 4.17112 16.7995 3.95514 15.4724 4.00774ZM15.8629 17.4489C14.8514 17.4477 13.8817 17.0454 13.1664 16.3302C12.4512 15.6149 12.0489 14.6452 12.0477 13.6337C12.0483 12.6217 12.4504 11.6514 13.1656 10.9356C13.8809 10.2198 14.851 9.81698 15.8629 9.81566C16.8744 9.81679 17.8442 10.2191 18.5594 10.9343C19.2747 11.6496 19.677 12.6193 19.6781 13.6308C19.6777 14.6428 19.2758 15.6133 18.5604 16.3292C17.8451 17.045 16.8749 17.4477 15.8629 17.4489Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTracker);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tracker.a2cbfc1c8c905b977047ff68de30e849.svg";